import { render } from "./GetInfoAluno.vue?vue&type=template&id=276c4de5"
import script from "./GetInfoAluno.vue?vue&type=script&lang=js"
export * from "./GetInfoAluno.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__